import { put, takeLatest } from 'redux-saga/effects';
import { updateTotalCount } from 'store/helpers/tableAndToolbar/actions';
import { actions as userMessaging } from '../userMessaging';
import {
  IMPORT_FILE,
  CREATE_SEGMENTED_LIST,
  CREATE_LIST,
  UPDATE_LIST_NAME,
  DELETE_LIST,
  GET_ACTIVE_SUBSCRIBERS,
  GET_SUPPRESSED_SUBSCRIBERS,
  REMOVE_SUBSCRIBER,
  DELETE_SEGMENTED_LIST,
  UPDATE_SEGMENTED_LIST,
  GET_SEGMENTED_LIST,
  SUPPRESS_SUBSCRIBER,
  ACTIVATE_SUBSCRIBER,
  GET_SAMPLE_FILE,
  GET_IMPORT_STATUS_LIST,
  GET_ERROR_FILE,
  GET_PAGINATED_LISTS,
  GET_PAGINATED_SEGMENTED_LISTS,
  GET_LIST,
  GET_FILE_NAME_IMPORT_STATUS,
  GETTING_PAGINATED_LISTS_FAILED,
  GETTING_PAGINATED_SEGMENTED_LISTS_FAILED,
  GETTING_ACTIVE_SUBSCRIBERS_FAILED,
  GETTING_SUPPRESSED_SUBSCRIBERS_FAILED,
  GETTING_IMPORT_STATUS_LIST_FAILED,
  GETTING_LIST_FAILED,
  GETTING_SAMPLE_FILE_FAILED,
  GETTING_SEGMENTED_LIST_FAILED,
  GETTING_ERROR_FILE_FAILED,
  GETTING_FILE_NAME_IMPORT_STATUS_FAILED,
  GET_ALL_LISTS,
  GET_ALL_SEGMENTED_LISTS,
  DELETE_ALL_SUBSCRIBERS,
  CREATE_SUBSCRIBER_LIST,
  UPDATE_SUBSCRIBER_LIST,
  GET_ADDITIONAL_PROFILE_LIST,
} from './actions';
import {
  createList,
  createSegmentedListForList,
  deleteCurrentList,
  deleteCurrentSegmentedList,
  getSampleCsvFile,
  getActiveSubscribersForList,
  getSegmentedList,
  getSuppressedSubscribersForList,
  removeSubscriberFromList,
  activateCurrentSubscriber,
  suppressCurrentSubscriber,
  updateCurrentListName,
  updateSegmentedListForList,
  uploadSubscribersFile,
  getImportStatusListForListId,
  getErrorCsvFile,
  getPaginatedListsIfNeeded,
  getPaginatedSegmentedListsIfNeeded,
  getCurrentListIfNeeded,
  getCurrentFileNameStatus,
  getAllLists,
  getAllSegmentedLists,
  deleteAllSubscribers,
  createSubscriberList,
  updateSubscriberList,
  getAdditionalProfileList
} from './sagas';

function* GetListSaga() {
  yield takeLatest(GET_LIST, getCurrentListIfNeeded);
}

function* GetPaginatedListsSaga() {
  yield takeLatest(GET_PAGINATED_LISTS, getPaginatedListsIfNeeded);
}

function* CreateListSaga() {
  yield takeLatest(CREATE_LIST, createList);
}

function* UpdateListNameSaga() {
  yield takeLatest(UPDATE_LIST_NAME, updateCurrentListName);
}

function* DeleteListSaga() {
  yield takeLatest(DELETE_LIST, deleteCurrentList);
}

function* UploadSubscribersSaga() {
  yield takeLatest(IMPORT_FILE, uploadSubscribersFile);
}

function* GetActiveSubscribersSaga() {
  yield takeLatest(GET_ACTIVE_SUBSCRIBERS, getActiveSubscribersForList);
}

function* GetSuppressedSubscribersSaga() {
  yield takeLatest(GET_SUPPRESSED_SUBSCRIBERS, getSuppressedSubscribersForList);
}

function* SuppressSubscriberSaga() {
  yield takeLatest(SUPPRESS_SUBSCRIBER, suppressCurrentSubscriber);
}

function* ActivateSubscriberSaga() {
  yield takeLatest(ACTIVATE_SUBSCRIBER, activateCurrentSubscriber);
}

function* RemoveSubscriberSaga() {
  yield takeLatest(REMOVE_SUBSCRIBER, removeSubscriberFromList);
}

function* GetPaginatedSegmentedListsSaga() {
  yield takeLatest(
    GET_PAGINATED_SEGMENTED_LISTS,
    getPaginatedSegmentedListsIfNeeded
  );
}

function* GetSegmentedListSaga() {
  yield takeLatest(GET_SEGMENTED_LIST, getSegmentedList);
}

function* CreateSegmentedListSaga() {
  yield takeLatest(CREATE_SEGMENTED_LIST, createSegmentedListForList);
}

function* UpdateSegmentedListSaga() {
  yield takeLatest(UPDATE_SEGMENTED_LIST, updateSegmentedListForList);
}

function* DeleteSegmentedListSaga() {
  yield takeLatest(DELETE_SEGMENTED_LIST, deleteCurrentSegmentedList);
}

function* GetSampleFileSaga() {
  yield takeLatest(GET_SAMPLE_FILE, getSampleCsvFile);
}

function* GetImportStatusListSaga() {
  yield takeLatest(GET_IMPORT_STATUS_LIST, getImportStatusListForListId);
}

function* GetErrorFileSaga() {
  yield takeLatest(GET_ERROR_FILE, getErrorCsvFile);
}

function* GetFileNameImportStatusSaga() {
  yield takeLatest(GET_FILE_NAME_IMPORT_STATUS, getCurrentFileNameStatus);
}

function* GetAllListsSaga() {
  yield takeLatest(GET_ALL_LISTS, getAllLists);
}

function* GetAllSegmentedListsSaga() {
  yield takeLatest(GET_ALL_SEGMENTED_LISTS, getAllSegmentedLists);
}

function* HandleFailuresSaga() {
  yield takeLatest(
    [
      GETTING_PAGINATED_LISTS_FAILED,
      GETTING_LIST_FAILED,
      GETTING_ACTIVE_SUBSCRIBERS_FAILED,
      GETTING_SUPPRESSED_SUBSCRIBERS_FAILED,
      GETTING_SAMPLE_FILE_FAILED,
      GETTING_PAGINATED_SEGMENTED_LISTS_FAILED,
      GETTING_SEGMENTED_LIST_FAILED,
      GETTING_IMPORT_STATUS_LIST_FAILED,
      GETTING_ERROR_FILE_FAILED,
      GETTING_FILE_NAME_IMPORT_STATUS_FAILED
    ],
    function*(action) {
      yield put(
        userMessaging.setMessageForFailedAction({
          type: action.type,
          error: action.payload
        })
      );
    }
  );
}

function* UpdateCountForFailuresSaga() {
  yield takeLatest(
    [
      GETTING_PAGINATED_LISTS_FAILED,
      GETTING_PAGINATED_SEGMENTED_LISTS_FAILED,
      GETTING_ACTIVE_SUBSCRIBERS_FAILED,
      GETTING_SUPPRESSED_SUBSCRIBERS_FAILED,
      GETTING_IMPORT_STATUS_LIST_FAILED
    ],
    function*() {
      yield put(updateTotalCount(0));
    }
  );
}

function* DeleteAllSubscribersSaga() {
  yield takeLatest(DELETE_ALL_SUBSCRIBERS, deleteAllSubscribers);
}

function* CreateSubscriberListSaga() {
  yield takeLatest(CREATE_SUBSCRIBER_LIST, createSubscriberList);
}

function* UpdateSubscriberListSaga() {
  yield takeLatest(UPDATE_SUBSCRIBER_LIST, updateSubscriberList);
}

function* GetAdditionalProfileListSaga() {
  yield takeLatest(GET_ADDITIONAL_PROFILE_LIST, getAdditionalProfileList);
}

export default [
  GetListSaga,
  GetPaginatedListsSaga,
  CreateListSaga,
  UpdateListNameSaga,
  DeleteListSaga,
  UploadSubscribersSaga,
  GetActiveSubscribersSaga,
  GetSuppressedSubscribersSaga,
  SuppressSubscriberSaga,
  ActivateSubscriberSaga,
  RemoveSubscriberSaga,
  GetSegmentedListSaga,
  GetPaginatedSegmentedListsSaga,
  CreateSegmentedListSaga,
  UpdateSegmentedListSaga,
  DeleteSegmentedListSaga,
  GetSampleFileSaga,
  GetImportStatusListSaga,
  GetErrorFileSaga,
  GetFileNameImportStatusSaga,
  HandleFailuresSaga,
  UpdateCountForFailuresSaga,
  GetAllListsSaga,
  GetAllSegmentedListsSaga,
  DeleteAllSubscribersSaga,
  CreateSubscriberListSaga,
  UpdateSubscriberListSaga,
  GetAdditionalProfileListSaga
];
